export const FIXED_SIGNUP_FOOTER_ID = 'signup-step-footer';
